import { IProduct } from '@/interfaces/api/product/IProduct';

type ProductCardProps = {
	product: IProduct;
	isSelected: boolean;
	handleSelect: (product: IProduct) => void;
	disabled: boolean;
};

const ProductCardSimple = ({
	product,
	isSelected,
	handleSelect,
	disabled,
}: ProductCardProps) => {
	return (
		<div
			className={`text-sm box-border h-fit ${
				isSelected ? 'border-[2px] rounded-lg' : ''
			}`}
		>
			<div
				className={`duration-200 ${!disabled && 'cursor-pointer'} ${
					isSelected ? 'scale-75' : 'scale-1'
				}`}
				onClick={() => !disabled && handleSelect(product)}
				aria-hidden="true"
				data-test={`product-id-${product.id}`}
			>
				<div className="flex justify-center h-[200px]">
					<img
						alt={product.title}
						src={
							product.image?.src ||
							'data:image/svg+xml;charset=UTF-8,' +
								encodeURIComponent(`
								<svg xmlns="http://www.w3.org/2000/svg" width="216" height="144" viewBox="0 0 216 144">
								<rect width="100%" height="100%" fill="#e5e7eb" />
								<text x="50%" y="50%" fill="#6b7280" font-size="14" font-family="Arial, Helvetica, sans-serif"
										text-anchor="middle" dominant-baseline="middle">
									No Image
								</text>
								</svg>
							`)
						}
						loading="lazy"
						className="h-full object-cover rounded-lg"
					/>
				</div>
				<p className="mt-2 font-medium text-center">{product.title}</p>
			</div>
		</div>
	);
};

export default ProductCardSimple;
